"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'YsImage',
  props: {
    src: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      previewVisible: false
    };
  },
  methods: {
    handlePreviewClick() {
      this.$refs.imagePreviewRef.show(this.src);
    }
  }
};